import Vue from "vue";
import Router from "vue-router";
import main from "@/components/main";
import personalHarassment from "@/components/personal_harassment";
import personalSignIn from "@/components/personal_sign_in";
import personalSignUp from "@/components/personal_sign_up";
import personalService from "@/components/personal_service";
import businessSignIn from "@/components/business_sign_in";
import businessService from "@/components/business_service";
import faq from "@/components/faq";
import about from "@/components/about";
import support from "@/components/support";
import supportSubmit from "@/components/support_submit";
import supportTrack from "@/components/support_track";
import plansPricing from "@/components/plans_pricing";
import contact from "@/components/contact";
import press from "@/components/press";
import terms from "@/components/terms";
import privacy from "@/components/privacy";
import personal_sign_in_forgot from "@/components/personal_sign_in_forgot";
import celebrity_vip_problems from "@/components/celebrity_vip_problems";
import business_problems from "@/components/business_problems";
import technology from "@/components/technology";
import signup from "@/components/signup";

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "main",
      component: main,
      meta: {
        title: "Clear Me Out - Specialized Content Removal Services",
        metaTags: [
          {
            name: "description",
            content:
              "ClearMeOut.com is the world's first ever AI based content removal service taking care of cyber Content and Privacy"
          },
          {
            name: "keywords",
            content:
              "takedown, removal, defamation, personal, business, images, videos, audios, content, Intellectual property"
          }
        ]
      }
    },
    {
      path: "/personal-cyber-harassments",
      name: "personal_harassment",
      component: personalHarassment,
      meta: {
        title: "Clear Me Out - Personal Cyber Harassments",
        metaTags: [
          {
            name: "description",
            content:
              "Understanding Cyber Harassments with clarification, definition and concepts to find ways for the relief of mental stress caused by them."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, revenge porn, sextortion, cyber harassment, impersonation, blackmail, nude, naked, sexual"
          }
        ]
      }
    },
    {
      path: "/celebrity-vip",
      name: "celebrity_vip_problems",
      component: celebrity_vip_problems,
      meta: {
        title: "Clear Me Out - Celebrity/VIP Cyber Harassments",
        metaTags: [
          {
            name: "description",
            content:
              "Understanding celebrities/VIPs popularity based cyber harassments such as celebgate, scandal, doctored/faked images, i-cloud leaks and deepfake for removal."
          },
          {
            name: "keywords",
            content:
              "Removal, takedown, impersonation, blackmail, flappening, celebgate, scandal, photoshop, iCloud leaks, deepfake."
          }
        ]
      }
    },
    {
      path: "/Internet-business-issues",
      name: "/business_problems",
      component: business_problems,
      meta: {
        title: "Clear Me Out - Internet Business Issues",
        metaTags: [
          {
            name: "description",
            content:
              "Understanding businesses’ online problems such as fake/false reviews, usurpation of IP, Infringement of Copyrights and brand impersonation for suppression."
          },
          {
            name: "keywords",
            content:
              "Removal, takedown, fake/false reviews, brand impersonation, intellectual property, copyright, reputation, piracy, usurpation, infringement"
          }
        ]
      }
    },
    {
      path: "/personal_sign_in",
      name: "personal_sign_in",
      component: personalSignIn,
      meta: {
        title: "Clear Me Out - Personal Sign In",
        metaTags: [
          {
            name: "description",
            content:
              "With no hesitation, sign in or speak to us to get rid of your mind-boggling issues on cyber harassment."
          }
        ]
      }
    },
    {
      path: "/personal_sign_up",
      name: "personal_sign_up",
      component: personalSignUp,
      meta: {
        title: "Clear Me Out - Personal Sign Up",
        metaTags: [
          {
            name: "description",
            content:
              "Understanding Cyber Harassments with their clarification, definition and concepts to find ways for relief of mental stress caused by them."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, revenge porn, sextortion, cyber harassment, impersonation, blackmail, nude, naked, sexual"
          }
        ]
      }
    },
    {
      path: "/business_sign_in",
      name: "business_sign_in",
      component: businessSignIn,
      meta: {
        title: "Clear Me Out - Business Sign In",
        metaTags: [
          {
            name: "description",
            content:
              "Sign in to get the most advanced business services on content monitoring, removal & management."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, revenge porn, sextortion, cyber harassment, impersonation, blackmail, nude, naked, sexual"
          }
        ]
      }
    },
    {
      path: "/pricing",
      name: "pricings",
      component: plansPricing,
      meta: {
        title: "Clear Me Out - Plans and Pricing",
        metaTags: [
          {
            name: "description",
            content:
              "Choose a plan and find the right solution for your needs."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, plans and pricing, packages, delete, content, image, video, audio, defamation."
          }
        ]
      }
    },
    {
      path: "/faq",
      name: "faq",
      component: faq,
      meta: {
        title: "Clear Me Out - FAQ",
        metaTags: [
          {
            name: "description",
            content:
              "Need some help for placing your request or got a burning question that you need answered pronto?Understanding Cyber Harassments with their clarification, definition and concepts to find ways for relief of mental stress caused by them."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, faq, content, image, video, audio, defamation, stolen."
          }
        ]
      }
    },
    {
      path: "/support",
      name: "support",
      component: support,
      meta: {
        title: "Clear Me Out - Support Centre",
        metaTags: [
          {
            name: "description",
            content:
              "You can count on our team, which takes personal pride in giving top-notch service to each and every customer confidentially."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, support, centre, delete, content, image, video, audio, defamation."
          }
        ]
      }
    },
    {
      path: "/support/portal/login",
      name: "supportSubmit",
      component: supportSubmit,
      meta: {
        title: "Clear Me Out - Submit Ticket",
        metaTags: [
          {
            name: "description",
            content:
              "Use this form to submit a support ticket to our highly trained staff."
          },
        ]
      }
    },
    {
      path: "/support/portal/track",
      name: "supportTrack",
      component: supportTrack,
      meta: {
        title: "Clear Me Out - Track Ticket",
        metaTags: [
          {
            name: "description",
            content:
              "Use your email address and ticket number to track the status of your ticket."
          },
        ]
      }
    },
    {
      path: "/contact-us",
      name: "contact",
      component: contact,
      meta: {
        title: "Clear Me Out - Contact Us",
        metaTags: [
          {
            name: "description",
            content:
              "Need any assistance from Clear Me Out? We are always ready with our unmatchable services."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, revenge porn, sextortion, cyber harassment, impersonation, blackmail, nude, naked, sexual"
          }
        ]
      }
    },
    {
      path: "/personal",
      name: "personalService",
      component: personalService,
      meta: {
        title: "Clear Me Out - Personal Services",
        metaTags: [
          {
            name: "description",
            content:
              "We provide cutting edge solutions for cyber harassed individuals through permanently removing stolen/doctored contents online and locating their offenders."
          },
          {
            name: "keywords",
            content:
              "Removal, takedown, individual, delete, content, image, video, audio, defamation, stolen."
          }
        ]
      }
    },
    {
      path: "/business",
      name: "businessService",
      component: businessService,
      meta: {
        title: "Clear Me Out - Business Services",
        metaTags: [
          {
            name: "description",
            content:
              "Protecting your business from online defamatory statements, fake/false reviews, threats on reputation, IP usurpation or copyright infringement."
          },
          {
            name: "keywords",
            content:
              "Removal, takedown, piracy, fake reviews, business, intellectual property, copyright, defamation, usurpation, infringement "
          }
        ]
      }
    },
    {
      path: "/about",
      name: "aboutUs",
      component: about,
      meta: {
        title: "Clear Me Out - About Us",
        metaTags: [
          {
            name: "description",
            content:
              "Providing cutting edge solutions for any kind of cyber abuse by a team of dedicated experts possessing extraordinary skills."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, about, us, content, image, video, audio, defamation, stolen."
          }
        ]
      }
    },
    {
      path: "/press",
      name: "press",
      component: press,
      meta: {
        title: "Clear Me Out - Press",
        metaTags: [
          {
            name: "description",
            content:
              "Marketing and press-related communications."
          }
        ]
      }
    },
    {
      path: "/terms-of-service",
      name: "terms",
      component: terms,
      meta: {
        title: "Clear Me Out - Terms of Service",
        metaTags: [
          {
            name: "description",
            content:
              "Addresses the various rights and responsibilities of those who use the services offered by us."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, tos, terms of service, delete, content, image, video, audio, defamation."
          }
        ]
      }
    },
    {
      path: "/privacy-policy",
      name: "privacy",
      component: privacy,
      meta: {
        title: "Clear Me Out - Privacy Policy",
        metaTags: [
          {
            name: "description",
            content:
              "Relates to the collection, use and secure of your personal/business information submitted to us."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, privacy, policy, delete, content, image, video, audio, defamation."
          }
        ]
      }
    },
    {
      path: "/forgot-password",
      name: "personal_sign_in_forgot",
      component: personal_sign_in_forgot,
      meta: {
        title: "Clear Me Out - Forgot Password",
        metaTags: [
          {
            name: "description",
            content:
              "Understanding Cyber Harassments with their clarification, definition and concepts to find ways for relief of mental stress caused by them."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, revenge porn, sextortion, cyber harassment, impersonation, blackmail, nude, naked, sexual"
          }
        ]
      }
    },
    {
      path: "/technology",
      name: "technology",
      component: technology,
      meta: {
        title: "Clear Me Out - Technology",
        metaTags: [
          {
            name: "description",
            content:
              "AI-based Robust Eye detects any type of contents in the entire cyberspace and removes all affected from all public sites/locations."
          },
          {
            name: "keywords",
            content:
              "removal, takedown, technology, ret, delete, content, image, video, audio, defamation."
          }
        ]
      }
    },
    {
      path: "/signup",
      name: "signup",
      component: signup,
      meta: {
        title: "Clear Me Out - Personal Sign Up",
        metaTags: [
          {
            name: "description",
            content:
              "Create an account to obtain an AI technology-based content removal service with many optional supporting services"
          },
          {
            name: "keywords",
            content:
              "removal, takedown, revenge porn, sextortion, cyber harassment, impersonation, blackmail, nude, naked, sexual"
          }
        ]
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  console.log("to", to);
  console.log("from", from);
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  console.log("nearestWithTitle", nearestWithTitle);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  console.log("nearestWithMeta", nearestWithMeta);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js